import { ModuleName } from "./types";

export const MODULES_PRIORITY: Record<ModuleName, number> = {
  [ModuleName.AddressSearch]: 6,
  [ModuleName.BasemapSelect]: 1,
  [ModuleName.BookmarkControl]: 3,
  [ModuleName.Catalog]: 4,
  [ModuleName.FeatureCard]: 1,
  [ModuleName.LayerList]: 1,
  [ModuleName.SharedLayerList]: 1,
  [ModuleName.Map]: 1,
  [ModuleName.MeasurerControl]: 4,
  [ModuleName.Notifications]: 3,
  [ModuleName.Print]: 3,
  [ModuleName.ProjectPanel]: 1,
  [ModuleName.ScaleControl]: 2,
  [ModuleName.DateFilterControl]: 5,
  [ModuleName.DateFilter]: 1,
  [ModuleName.GeoLocation]: 5,
  [ModuleName.Snapping]: 5,
  [ModuleName.Style]: 3,
  [ModuleName.StyleEditor]: 3,
  [ModuleName.Dashboard]: 3,
  [ModuleName.Presentation]: 3,
  [ModuleName.LayerConfiguration]: 3,
  [ModuleName.ProjectConfiguration]: 3,
  [ModuleName.ConfigurationsTable]: 3,
  [ModuleName.SymbolLibrary]: 3,
  [ModuleName.Table]: 3,
  [ModuleName.Tools]: 2,
  [ModuleName.Feedback]: 4,
  [ModuleName.Help]: 4,
  [ModuleName.ZoomSelection]: 3,
  [ModuleName.EqlQuery]: 3,
  [ModuleName.EqlLayerTable]: 3,
  [ModuleName.EqlQueryTable]: 3,
};
